import styled from 'styled-components';
import { S_FlexBox } from '../../../style/FlexBox.style';

export const LogoWrapper = styled(S_FlexBox)`
  margin-bottom: 40px;
  & > img {
    width: 120px;
  }
`;
